import { render, staticRenderFns } from "./ScrapingSettingsContent.vue?vue&type=template&id=72624ee0&scoped=true"
import script from "./ScrapingSettingsContent.vue?vue&type=script&lang=js"
export * from "./ScrapingSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./ScrapingSettingsContent.vue?vue&type=style&index=0&id=72624ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72624ee0",
  null
  
)

export default component.exports